import React from 'react'

const FiboBeta = (props) => {
  return (
    <div
      style={props.labelStyle}>
      { props.label }
      <sup
        style={styles.betaLogo}>
        beta
      </sup>
    </div>
  )
}

const styles = {
  betaLogo: {
    fontSize: 12,
    color: '#b04f4f',
    verticalAlign: 'super',
    lineHeight: 0,
    paddingLeft: 4
  }
}

export default FiboBeta



// WEBPACK FOOTER //
// ./src/common/FiboBeta.js